module.exports = __webpack_public_path__ + "static/media/escapeFat.d99426d1.svg";